export default function(request, reject, rootAddress) {
  var service = {};
  /**
   * 获得总预约数
   */
  service.getConfig = function() {
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/get_config', {}).then((response) => {
      if (response.status === 1 /* 成功 */) {
        return response.data;
      }
      return reject(response);
    });
  };

  /**
   * 获得短信验证码
   * @param phone 手机号
   * @param captchaObj 极验参数
   */
  service.getPhoneCode = function({ phone, ...captchaObj }) {
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/get_phone_code', {
      phone,
      type: 3,
      ...captchaObj
    }).then((response) => {
      if (response.status === 1 /* 成功 */) {
        return response.data;
      }
      return reject(response);
    });
  };

  /**
   * 预约
   * @param code 手机验证码
   * @param from 预约来源(default：官方， fab：fab页)
   * @param phone 手机号
   * @param utm_source utm来源
   */
  service.subscribe = function(code, from, phone, utm_source) {
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/subscribe', {
      code,
      from,
      phone,
      utm_source
    }).then((response) => {
      if (response.status === 1 /* 成功 */) {
        return response.data;
      }
      return reject(response);
    });
  };

  /**
   * 测试资格查询
   * @param code 手机验证码
   * @param phone 手机号
   */
  service.checkQualification = function(code, phone) {
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/check_qualification', {
      code,
      phone
    }).then((response) => {
      if (response.status === 1 /* 成功 */) {
        return response.data;
      }
      return reject(response);
    });
  };
  /**
   * 测试招募配置
   * @returns {*}
   */
  service.recruitConfig = function() {
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/recruit_config', {}).then((response) => {
      if (response.status === 1 /* 成功 */) {
        return response.data;
      }
      return reject(response);
    });
  };

  /**
   * 测试招募预约
   * @returns {*}
   */
  service.subscribeByRecruit = function(params) {
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/subscribe_by_recruit', {
      phone: params.phone,
      code: params.code,
      utm_source: params.utmSource
    }).then((response) => {
      if (response.status === 1 /* 成功 */) {
        return response.data;
      }
      return reject(response);
    });
  };
  /**
   * 测试招募预约
   i @returns {*}
   */
  service.completeQuestion = function(params) {
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/complete_question', {
      user_id: params.userId
    }).then((response) => {
      if (response.status === 1 /* 成功 */) {
        return response.data;
      }
      return reject(response);
    });
  };
  /**
   * 退出登录

   i @returns {*}
   */
  service.logout = function(params) {
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/logout', {}).then((response) => {
      if (response.status === 1 /* 成功 */) {
        return response.data;
      }
      return reject(response);
    });
  };
  service.completeQuestion = function(user_id) {
    return request.jsonp(rootAddress + '/webapp/cbsubscribe231024/complete_question', { user_id }).then((response) => {
      if (response.status === 1 /* 成功 */) {
        return response.data;
      }
      return reject(response);
    });
  };
  return service;
}
